import cn from "classnames";
import styles from "./index.module.scss";

interface BaseBtnProps {
  text: string;
  className?: string;
  onClick?: () => void;
}

export default function BaseBtn({ text, className, onClick }: BaseBtnProps) {
  return (
    <div
      className={cn(styles.baseBtn, className || "")}
      onClick={() => {
        onClick && onClick();
      }}
    >
      <div>
        <span>{text}</span>
      </div>
    </div>
  );
}
